import Countdown, {zeroPad} from "react-countdown";
import classNames from "classnames";

export default function BidCountdown({
    date,
    onComplete,
    warningMinutes = 1,
    showSeconds = true,
    showSecondsUnderMinutes = null,
    boldUnderMinutes = null,
    suffix = null,
    completedLabel = 'Bidding Ended',
    className,
    ...props
}) {
    const countdownRenderer = ({ days, hours, minutes, seconds, total, completed }) => {
        const remainingMinutes = total / 1000 / 60;
        const timerWarning = warningMinutes !== 0 && days === 0 && hours === 0 && minutes < warningMinutes;
        const timerStrong = boldUnderMinutes !== null && remainingMinutes < boldUnderMinutes;
        const shouldShowSeconds = showSeconds || (
            showSecondsUnderMinutes !== null && remainingMinutes < showSecondsUnderMinutes
        );
        const shouldShowHours = days > 0 || hours > 0;
        const shouldShowMinutes = shouldShowHours || minutes > 0;

        if (completed) {
            if (completedLabel === null) return null;

            return (
                <span className={"text-red-500"} data-countdown="" data-title="">
                    {completedLabel}
                </span>
            );
        }
        return (
            <span
                className={classNames(
                    className,
                    timerStrong && "font-semibold",
                    timerWarning && "text-red-500"
                )}
                data-countdown=""
            >
                {days > 0 && `${days}d `}
                {shouldShowHours ? `${zeroPad(hours)}h ` : null}
                {shouldShowMinutes ? `${zeroPad(minutes)}m` : null}
                {shouldShowSeconds ? `${shouldShowMinutes ? ' ' : ''}${zeroPad(seconds)}s` : null}
                {suffix}
            </span>
        )
    }

    return (
        <Countdown key={date} date={date} renderer={countdownRenderer} onComplete={onComplete}/>
    )
}
